<template>
  <section class="section">
    <div class="container">
      <h1 class="title">タスクの新規登録</h1>
      <form @submit.prevent="submit" method="post">
        <template v-if="modules.module_mode">
          <div class="field is-grouped is-grouped-multiline">
            <div class="field control">
              <label class="label">モード<span class="has-text-danger is-size-7">※モードは自動選択です</span></label>
              <div class="select">
                <select v-model="inputForm.fk_mode" disabled>
                  <option v-bind:value="mode.mode_available">
                    {{ mode.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </template>
        <div class="field is-grouped is-grouped-multiline">
          <div class="field control">
            <label class="label">緊急性</label>
            <div class="select">
              <select v-model="inputForm.fk_urgency" required>
                <option v-for="urgency in urgencys" v-bind:key="urgency.id" v-bind:value="urgency.id">
                  {{ urgency.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="field control">
            <label class="label">登録日</label>
            <div class="control">
              <flat-pickr v-model="inputForm.date" class="input" :config="config"></flat-pickr>
            </div>
          </div>
          <div class="field control">
            <label class="label">登録者</label>
            <div class="select">
              <select v-model="inputForm.fk_register_id" disabled>
                <option v-for="register in registers" v-bind:key="register.id" v-bind:value="register.id">
                  {{ register.dispname }}
                </option>
              </select>
            </div>
          </div>
          <div class="field control">
            <label class="label">担当者</label>
            <div class="select">
              <select v-model="inputForm.fk_rep_id" required>
                <option v-for="register in registers" v-bind:key="register.id" v-bind:value="register.id">
                  {{ register.dispname }}
                </option>
              </select>
            </div>
          </div>
          <div class="field control">
            <label class="label">マップへの表示</label>
            <div class="select">
              <select v-model="inputForm.mapshow" required>
                <option v-for="mapshow in mapShows" v-bind:key="mapshow.id" v-bind:value="mapshow.id">
                  {{ mapshow.dispname }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="field control">
          <label class="label">件名</label>
          <div class="control">
            <input class="input" type="text" placeholder="件名" v-model="inputForm.task_title" required>
          </div>
        </div>
        <div class="columns">
          <div class="column is-7">
            <div class="field control">
              <label class="label">詳細</label>
              <div class="control">
                <textarea class="textarea" placeholder="詳細" v-model="inputForm.comment" maxlength="200"></textarea>
              </div>
              <div>
                <p class="is-size-7">あと{{ 200 - inputForm.comment.length }}文字</p>
              </div>
            </div>
            <!-- 写真表示場所の確保 -->
            <br />
            <div class="columns">
              <div class="column" v-for="(src, index) in imageURI" :key="index">
                <div class="field">
                  <div class="preview-item">
                    <img
                      class="preview-item-file"
                      :src="src"
                      alt=""
                      width="120"
                      height="120"
                    />
                    <div class="preview-item-btn" @click="remove(index)">
                      <span class="delete">close</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="file" v-if="imageURI.length < 4">
              <label class="file-label">
                <input class="file-input" type="file" name="resume" @change="onFileChange" accept=".jpg,.gif,.png,image/gif,image/jpeg,image/png">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fas fa-upload"></i>
                  </span>
                  <span class="file-label">
                    ファイルを添付...
                  </span>
                </span>
              </label>
            </div>
          </div>
          <!-- 写真ここまで -->
          <div class="column is-5">
            <div class="field control">
              <label class="label">発見場所</label>
              <button class="button is-info is-pulled-right" @click.prevent="getGeoLocation">位置情報再取得</button>
              <div class="control">
                <div id="map"></div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <button type="submit" class="button is-fullwidth is-primary" v-bind:disabled="isSubmit">データ登録</button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import imageResize from '../../assets/js/imageResize.js'
import flatPickr from 'vue-flatpickr-component'
import { Japanese } from 'flatpickr/dist/l10n/ja'
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
const geolocation = require('geolocation')
import {T_STD, T_PALE, O_STD, BASEGIS} from '../../util.js'
// const maxSize = 1440
import loadImage from 'blueimp-load-image'
const THUMBNAIL_WIDTH = 1440 // 画像リサイズ後の横の長さの最大値
const THUMBNAIL_HEIGHT = 1080 // 画像リサイズ後の縦の長さの最大値

export default {
  data: function(){
    return {
      map: null,
      layer: L.featureGroup(),
      inputForm: {
        task_title: '',
        comment: '',
        date: '',
        fk_urgency: '',
        fk_register_id: '',
        fk_rep_id: '',
        mapshow: '1',
        fk_mode: '',
        locations: '',
        images: [], // ストレージアップ用。Blob
        fk_status_id: 1,          //新規登録時は固定
        transmod_saigai_id: 0,          //新規登録時は固定
        common_id: 0,          //一般投稿用ID番号
      },
      imageURI: [], // アップロード確認用（画面表示用）。 URI
      mapShows: [
        { "id":"1", "dispname":"表示" },
        { "id":"0", "dispname":"非表示" },
      ],
      config:{
        locale: Japanese,
        altInput: false,
        enableTime: true,
        altFormat: 'Y-m-d H:i',
        dateFormat: 'Y-m-d H:i',
      },
      isSubmit: false,
      Map_BaseLayer: {
        "地理院地図 標準": T_STD,
        "地理院地図 淡色": T_PALE,
        "地理院地図 航空写真": BASEGIS,
        "OpenStreetMap 標準": O_STD
      },
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      modules: state => state.auth.modules,
      mode: state=> state.auth.mode,
      apiStatus: state => state.item.apiStatus,
      apiTaskStatus: state => state.task.apiStatus
    }),
    ...mapGetters({
      urgencys: 'item/urgencys',
      registers: 'item/users',
      reps: 'item/users',
    })
  },
  mounted(){
    this.$set(this.inputForm, 'date', new Date())
    this.$set(this.config, 'maxDate', new Date()) //現在の日付以降の新規登録はできないようにする
    this.initializeData()
  },
  components: {
    flatPickr,
  },
  methods:{
    async initializeData(){
      await this.$store.dispatch('item/getItems', {})
      if(this.apiStatus){
        this.$set(this.inputForm, 'fk_register_id', this.user.id)
        this.$set(this.inputForm, 'fk_rep_id', this.user.id)
        this.$set(this.inputForm, 'fk_mode', this.mode.mode_available)
        this.$set(this.inputForm, 'locations', L.latLng( this.user.location.lat, this.user.location.lng ))
        this.initMap()
      }
    },
    initMap() {
      this.map = L.map('map',
        {
          center: L.latLng( this.user.location.lat, this.user.location.lng ),
          zoom: 15,
          layers:[ new L.tileLayer('https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png', {
            attribution: "<a href='http://www.gsi.go.jp/kikakuchousei/kikakuchousei40182.html' target='_blank'>国土地理院</a>"
          })]
        }
      )
      L.control.layers(this.Map_BaseLayer, null, {
          collapsed: true
      }).addTo(this.map)
      this.map.on('click', e => {
        this.$set(this.inputForm , 'locations', e.latlng)
        this.markerCreate()
      })
      //位置情報自動取得
      this.getGeoLocation()
    },
    getGeoLocation() {
      geolocation.getCurrentPosition(function (err, position) {
        if (err) {
          this.$swal({
            position: 'bottom',
            toast: true,
            icon: 'question',
            html: '<div>位置情報の取得に失敗しました。</div><div>GPSが許可されているか確認してください。</div>',
            showConfirmButton: false,
            timer: 3500,
          })
          return
        }
        this.$set(this.inputForm , 'locations', L.latLng(position.coords.latitude,position.coords.longitude))
        this.markerCreate()
      }.bind(this))
    },
    markerCreate () {
      this.layer.clearLayers()
      this.isLocations = true
      let marker = L.marker(this.inputForm.locations, {
        icon: L.icon({
          iconUrl: 'static/nanikamitsuketa_mitsuketazou.gif',
          iconSize: [48, 48],
        }),
        draggable: true,
      })
      //ドラックイベント設定
      marker.on('dragend', function (e){
        this.inputForm.locations = e.target._latlng
      }.bind(this))
      this.layer.addLayer(marker)
      this.map.addLayer(this.layer)
      try{
        this.map.fitBounds(this.layer.getBounds())
      }catch(e){
        // console.log(e)
      }
    },
    onFileChange(e){
      // ユーザーが画像選択したら呼ばれる
      let files = e.target.files || e.dataTransfer.files
      if(files[0] === undefined) return false
      this.$store.commit('loading/setLoadingStatus', { loading: true })
      loadImage.parseMetaData(files[0], (data) => {
        const options = {
          maxHeight: THUMBNAIL_HEIGHT,
          maxWidth: THUMBNAIL_WIDTH,
          canvas: true
        }
        if (data.exif) {
          options.orientation = data.exif.get('Orientation')
        }
        //画像表示
        this.displayImage(files[0], options)

        if (data.exif) {
          if(this.isGpsLocation(data.exif)){
            const location = {
              lat: this.normalizeValues(data.exif.get('GPSLatitude'),data.exif.get('GPSLatitudeRef') === 'S'),
              lon: this.normalizeValues(data.exif.get('GPSLongitude'),data.exif.get('GPSLongitude') === 'W')
            }
            this.$swal({
              title: '確認',
              html: '<div>写真に位置情報が存在します。</div><div>写真の位置情報を地図に反映しますか？</div>',
              icon: "info",
              allowOutsideClick: false,
              showCancelButton: true,
            })
            .then((willDelete) => {
              if (willDelete.value) {
                this.$set(this.inputForm , 'locations', L.latLng(location))
                this.markerCreate()
              }
            })
          }
        }
      })
    },
    async displayImage (file, options,){
      await loadImage(
        file,
        async (canvas) => {
          const data = canvas.toDataURL(file.type)
          // data_url形式をblob objectに変換
          const blob = this.base64ToBlob(data, file.type)
          // objectのURLを生成
          const url = window.URL.createObjectURL(blob)
          this.imageURI.push(url)
          this.inputForm.images.push(data.replace(/^.*,/, ''))
        },
        options
      )
      this.$store.commit('loading/setLoadingStatus', { loading: false } )
    },
    base64ToBlob(base64, fileType) {
      const bin = atob(base64.replace(/^.*,/, ''))
      const buffer = new Uint8Array(bin.length)
      for (let i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i)
      }
      return new Blob([buffer.buffer], {
        type: fileType ? fileType : 'image/png'
      })
    },
    //写真にGPS情報が含まれているかどうか
    isGpsLocation(exifObj){
      if(exifObj.get('GPSLatitude') === ""){
        return false
      }
      return true
    },
    //度+分+秒に分割されている値を正規化
    normalizeValues(values,minus){
      var point = values[0] + (values[1] / 60) + (values[2] / 3600)
      return (minus) ? point * -1 : point
    },
    remove(index){
      this.imageURI.splice(index, 1)
      this.inputForm.images.splice(index, 1)
    },
    reset(){
      //TODO リロードを実装する
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    },
    async submit(){
      if(!moment(this.inputForm.date).isValid()){
        this.$swal({
          title: '確認',
          text: '登録日を入力してください',
          icon: 'error',
          confirmButtonText: '戻る',
        })
        return false
      }
      if(this.inputForm.images.length === 0){
        this.$swal({
          title: '確認',
          text: '最低1枚は写真を添付してください',
          icon: 'error',
          confirmButtonText: '戻る',
        })
        return false
      }
      this.isSubmit = true
      await this.$store.dispatch('task/newTask', this.inputForm)
      if(this.apiTaskStatus){
        this.$swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'タスクを新規追加しました。',
          showConfirmButton: false,
          timer: 2000
        }).then(() =>{
          this.reset()
        })
      }
    }
  }
}
</script>

<style scoped>

#map {
  width: 100%;
  height: 280px;
}

</style>